"use client";
import { jsx } from "react/jsx-runtime";
import React, { createContext } from "react";

const TabsContext = createContext({});
const TabProvider = ({ value, children }) => {
  const { activeTab, setActiveTab, tabs, root } = value;
  return /* @__PURE__ */ jsx(
    TabsContext.Provider,
    {
      value: {
        activeTab,
        setActiveTab,
        tabs,
        get root() {
          return root.current;
        }
      },
      children
    }
  );
};
var TabsContext_default = TabsContext;
export {
  TabProvider,
  TabsContext_default as default
};
